export { default as now } from './now.js';
export { default } from './date.default.js';



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/date.js
// module id = 2185
// module chunks = 41